import { definitionFactory, TStateTagValue } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const yearDefinition = definitionFactory({
  key: 'year',
  mapper: jsonQueryValue => {
    const result = jsonQueryValue.map((year: TStateTagValue) => ({
      label: `Сдача в ${year}`,
      value: year,
    }));

    return result;
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'year', options);
  },
});
